function listaConceptosPlame(conceptosPlame) {
  if (Array.isArray(conceptosPlame)) return conceptosPlame;
  return Object.values(conceptosPlame || {});
}

function buscarPlamePorId(conceptosPlame, id) {
  if (id == null || id === '') return null;
  return listaConceptosPlame(conceptosPlame).find((c) => Number(c.id) === Number(id)) || null;
}

function lineaDescuentoDesdePlame(conceptoAfecto, monto, origenCalculo) {
  const n = parseFloat(Number(monto).toFixed(2));
  return {
    codigoPlame: conceptoAfecto.codigo_plame,
    codigo_plame: conceptoAfecto.codigo_plame,
    codigo: conceptoAfecto.codigo_plame,
    concepto: conceptoAfecto.descripcion,
    descripcion: conceptoAfecto.descripcion,
    nombre: conceptoAfecto.descripcion,
    monto: n,
    plame_configuracion_id: conceptoAfecto.id,
    plame_configuracion: {
      id: conceptoAfecto.id,
      codigo_plame: conceptoAfecto.codigo_plame,
      descripcion: conceptoAfecto.descripcion,
    },
    tipo_concepto: 'descuento',
    origenCalculo,
  };
}

/**
 * Descuentos del empleado y de conceptos en tareos (misma regla que planilla general).
 */
export function extraerDescuentosPlanillaDesdeFuentes({
  tareosDetallados = [],
  conceptosDescuentosEmpleado = [],
  conceptosPlame = [],
} = {}) {
  const out = [];

  (conceptosDescuentosEmpleado || []).forEach((descuento) => {
    const monto = parseFloat(descuento.monto) || 0;
    if (monto <= 0) return;
    const plame = descuento.plame_configuracion
      || buscarPlamePorId(conceptosPlame, descuento.plame_configuracion_id);
    const codigo = plame?.codigo_plame || descuento.codigoPlame || descuento.codigo_plame;
    if (!codigo) return;
    out.push({
      codigoPlame: codigo,
      codigo_plame: codigo,
      codigo,
      concepto: plame?.descripcion || descuento.descripcion || descuento.concepto,
      descripcion: plame?.descripcion || descuento.descripcion || descuento.concepto,
      nombre: plame?.descripcion || descuento.descripcion || descuento.concepto,
      monto,
      plame_configuracion_id: plame?.id || descuento.plame_configuracion_id || null,
      plame_configuracion: plame ? {
        id: plame.id,
        codigo_plame: plame.codigo_plame,
        descripcion: plame.descripcion,
      } : descuento.plame_configuracion || null,
      tipo_concepto: 'descuento',
      origenCalculo: 'descuento_empleado',
    });
  });

  const acumulado = [];
  (tareosDetallados || []).forEach((tareo) => {
    (tareo.conceptos || []).forEach((concepto) => {
      if (concepto.tipo_concepto !== 'descuento' && concepto.tipo_concepto !== 'adelanto') return;
      const tb = String(concepto.tipo_boleta || 'plame').toLowerCase();
      if (tb === 'interna') return;
      const monto = parseFloat(concepto.monto) || 0;
      if (monto <= 0) return;

      const plameId = concepto.plame_configuracion_id
        || concepto.plame_configuracion?.id
        || concepto.id_plame_configuracion;

      if (plameId != null && plameId !== '') {
        const existente = acumulado.find((x) => Number(x.id_plame_configuracion) === Number(plameId));
        if (existente) existente.monto += monto;
        else acumulado.push({ id_plame_configuracion: plameId, monto });
        return;
      }

      const embebido = concepto.plame_configuracion;
      const codigo = concepto.codigo || concepto.codigo_plame || embebido?.codigo_plame;
      if (!codigo) return;
      const clave = `cod:${codigo}`;
      const existente = acumulado.find((x) => x.clave === clave);
      if (existente) existente.monto += monto;
      else {
        acumulado.push({
          clave,
          monto,
          conceptoAfecto: embebido?.codigo_plame ? embebido : {
            id: embebido?.id || null,
            codigo_plame: codigo,
            descripcion: concepto.descripcion || embebido?.descripcion || codigo,
          },
        });
      }
    });
  });

  acumulado.forEach((row) => {
    if (row.clave) {
      const conceptoAfecto = row.conceptoAfecto?.codigo_plame
        ? row.conceptoAfecto
        : buscarPlamePorId(conceptosPlame, row.conceptoAfecto?.id)
          || row.conceptoAfecto;
      if (!conceptoAfecto?.codigo_plame) return;
      const dup = out.find((d) => String(d.codigo_plame) === String(conceptoAfecto.codigo_plame));
      if (dup) {
        dup.monto = parseFloat((Number(dup.monto) + row.monto).toFixed(2));
        return;
      }
      out.push(lineaDescuentoDesdePlame(conceptoAfecto, row.monto, 'descuento_tareo'));
      return;
    }

    const conceptoAfecto = buscarPlamePorId(conceptosPlame, row.id_plame_configuracion);
    if (!conceptoAfecto) return;
    const dup = out.find((d) => Number(d.plame_configuracion_id) === Number(conceptoAfecto.id));
    if (dup) {
      dup.monto = parseFloat((Number(dup.monto) + row.monto).toFixed(2));
      return;
    }
    out.push(lineaDescuentoDesdePlame(conceptoAfecto, row.monto, 'descuento_tareo'));
  });

  return out;
}
